webpackJsonp([191311451125819],{

/***/ 964:
/***/ (function(module, exports) {

	module.exports = {"title":"Patterns","headline":"Patterns are the foundations of chess understanding and expertise in general. We offer the first training program that is specially targeted at improving your chess understanding via patterns based training","subtitle":"A new pattern based training method","p1":"What is it that makes a Master and a Grandmaster chess player?","p2":"According to scientific literature knowledge of patterns plays a key role.","p3":"Our original patterns based training method teaches the most important aspects of chess in a manner that is easy to remember. It was described in both a FIDE Trainer and also in a German A-Trainer thesis winning the praise of GM Adrian Mikhalchishin, the chairman of the FIDE Trainer Commission, for it´s originality and effectiveness.","p4":"According to an article in Nature","p4cite":"(Amidzic, Elbert, Fehr, Riehle & Wienbruch, 2001, p. 603, https://www.ncbi.nlm.nih.gov/pubmed/11493907)","p4citeLink":"https://www.ncbi.nlm.nih.gov/pubmed/11493907","p4s":", GMs need to learn 100,000 patterns and that pattern familiarity is what distinguishes Grandmasters from more ordinary players. ","p5":"Become the best version of yourself with personalized training!","download":{"line1":"Download OcuChess","line2":"Our most advanced learning platform"}}

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(9);
	
	var _Link = __webpack_require__(8);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _reactIntl = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  var content = props.content,
	      data = props.data;
	
	
	  var link = content.p4citeLink;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'wrapper' },
	      _react2.default.createElement(_gatsbyImage2.default, { sizes: data.img.childImageSharp.sizes })
	    ),
	    _react2.default.createElement(
	      _reactstrap.Container,
	      { className: 'py-4' },
	      _react2.default.createElement(
	        'h3',
	        { className: 'text-color-title' },
	        content.title
	      ),
	      _react2.default.createElement(
	        'blockquote',
	        { 'class': 'blockquote' },
	        _react2.default.createElement(
	          'p',
	          null,
	          content.headline
	        ),
	        _react2.default.createElement(
	          'footer',
	          { 'class': 'blockquote-footer' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'grandmaster' }),
	          ' ',
	          _react2.default.createElement(
	            'cite',
	            { title: 'Source Title' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'hedinn' })
	          )
	        )
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        null,
	        content.p1
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        null,
	        content.p2
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        null,
	        content.p3
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        null,
	        content.p4,
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: content.p4citeLink },
	          content.p4cite
	        ),
	        content.p4s
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        null,
	        content.p5
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        null,
	        content.p6
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: 'text-center' },
	        _react2.default.createElement(
	          _Link2.default,
	          { to: '/', className: 'btn btn-success btn-lg' },
	          content.download.line1,
	          ' ',
	          _react2.default.createElement('br', null),
	          content.download.line2
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _patternsLayout = __webpack_require__(180);
	
	var _patternsLayout2 = _interopRequireDefault(_patternsLayout);
	
	var _patterns = __webpack_require__(964);
	
	var _patterns2 = _interopRequireDefault(_patterns);
	
	var _reactHelmet = __webpack_require__(5);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'SciChess | Patterns'
	      )
	    ),
	    _react2.default.createElement(_patternsLayout2.default, _extends({ content: _patterns2.default }, props))
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-methods-patterns-index-en-js-3dcef74c9b09723ad8c0.js